import request from 'Request'

const AuthService = {
  async login({ username, password }) {
    return request.post('/auth/login', { username, password })
  },

  async get() {
    return request.get('/auth/get')
  },

  async logout() {
    return request.get('/auth/logout')
  },

  async setupAccount({ username, password, inviteCode }) {
    return request.put('/auth/setup-account', { username, password, inviteCode })
  }
}

export default AuthService
